import { Bool } from '@livecontrol/core-utils';
import _ from 'lodash';
// import validator from 'validator';
import { EventValidator } from './types';


export const validateSlides = (
  newEventInfo: EventValidator.EventInfo
): EventValidator.Errors => {
  const errors: EventValidator.Errors = {};
  const enabled = Bool.normalize(newEventInfo.useIntroAndOutroSlides);

  if (enabled && (newEventInfo.type !== EventValidator.ProductionType.MOBILE && newEventInfo.type !== EventValidator.ProductionType.MOBILE_KIT)) {
    const slideErrors: Record<string, string> = {};

    if (!newEventInfo.introSlide) {
      slideErrors.introSlide = EventValidator.ErrorMessages.INTRO_SLIDE_REQUIRED;
    }

    if (!newEventInfo.outroSlide) {
      slideErrors.outroSlide = EventValidator.ErrorMessages.OUTRO_SLIDE_REQUIRED;
    }

    if (Object.keys(slideErrors).length > 0) {
      _.merge(errors, { useIntroAndOutroSlides: slideErrors });
    }
  }

  return errors;
};

export const validateDefaultSlides = (
  newEventInfo: EventValidator.EventInfo,
  hasDefaultSlides: boolean
): EventValidator.Errors => {
  const errors: EventValidator.Errors = {};
  const enabled = Bool.normalize(newEventInfo.useIntroAndOutroSlides);

  if (enabled) {
    const slideErrors: Record<string, string> = {};

    if (!hasDefaultSlides) {
      slideErrors.introSlide = EventValidator.ErrorMessages.DEFAULT_INTRO_SLIDE_MISSING;
      slideErrors.outroSlide = EventValidator.ErrorMessages.DEFAULT_OUTRO_SLIDE_MISSING;
    }

    if (Object.keys(slideErrors).length > 0) {
      _.merge(errors, { useIntroAndOutroSlides: slideErrors });
    }
  }

  return errors;
};